import { emptyError } from "../../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const patientWsieReportSearchService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.patientwiseReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const patientWsieReportService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.patientwiseReport,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}